import * as React from "react";
const SvgTiktokPadding = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M21.373 11.207a3.83 3.83 0 0 1-1.75-2.51A3.7 3.7 0 0 1 19.557 8h-2.868l-.004 11.024c-.048 1.235-1.108 2.225-2.406 2.225-.404 0-.784-.096-1.118-.266-.767-.387-1.293-1.158-1.293-2.046 0-1.275 1.082-2.312 2.41-2.312.249 0 .487.04.712.106v-2.808c-.233-.03-.47-.049-.711-.049-2.91 0-5.278 2.271-5.278 5.063 0 1.713.892 3.229 2.253 4.145.857.578 1.9.918 3.025.918 2.91 0 5.278-2.271 5.278-5.063v-5.59a7 7 0 0 0 3.99 1.23v-2.75a4.1 4.1 0 0 1-2.173-.62"
  }
));
export default SvgTiktokPadding;
